import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import DatePicker from "react-datepicker";
import * as Moment from 'moment';
import { isLoaded } from '../../../Shared/api/apiTypes';
export const filterPeriods = [
    'vandaag',
    'morgen',
    'komende-zeven-dagen',
    'komende-dertig-dagen',
    'komend-halfjaar'
];
export const isFilterPeriod = (input)=>filterPeriods.includes(input);
export const periods = {
    'vandaag': "vandaag",
    'morgen': "morgen",
    'komende-zeven-dagen': "komende zeven dagen",
    'komende-dertig-dagen': "komende dertig dagen",
    'komend-halfjaar': "komend halfjaar"
};
const PeriodFilter = (p)=>/*#__PURE__*/ _jsxs("div", {
        className: `o-filter__field form__select form__item--icon left${isFilterPeriod(p.selectedPeriod) ? '' : ' form__select--visually-disabled'}`,
        children: [
            /*#__PURE__*/ _jsxs("select", {
                onChange: (e)=>{
                    e.stopPropagation();
                    p.selectPeriod(e.target.value);
                },
                disabled: !p.enabled,
                value: p.selectedPeriod,
                id: "rd-date",
                children: [
                    !isFilterPeriod(p.selectedPeriod) && /*#__PURE__*/ _jsx("option", {
                        children: "Kies een periode"
                    }),
                    filterPeriods.map((slug)=>/*#__PURE__*/ _jsx("option", {
                            value: slug,
                            children: periods[slug]
                        }, periods[slug]))
                ]
            }),
            /*#__PURE__*/ _jsx("svg", {
                className: "form__icon",
                width: "20px",
                height: "22px",
                "aria-hidden": "true",
                children: /*#__PURE__*/ _jsx("use", {
                    xlinkHref: "#icon--calendar-dnb"
                })
            })
        ]
    });
const RegionFilter = (p)=>/*#__PURE__*/ _jsxs("div", {
        className: "o-filter__field form__select form__item--icon left",
        children: [
            /*#__PURE__*/ _jsxs("select", {
                onChange: p.selectRegion,
                value: p.selectedRegion,
                disabled: !p.enabled,
                id: "rd-region",
                children: [
                    /*#__PURE__*/ _jsx("option", {
                        value: "",
                        children: "overal"
                    }, "overal"),
                    isLoaded(p.regions) && p.regions.sort().map((x, k)=>/*#__PURE__*/ _jsx("option", {
                            value: x.slug,
                            children: k
                        }, x.slug)).toArray()
                ]
            }),
            /*#__PURE__*/ _jsx("svg", {
                className: "form__icon",
                width: "20px",
                height: "24px",
                "aria-hidden": "true",
                children: /*#__PURE__*/ _jsx("use", {
                    xlinkHref: "#icon--pin-dnb"
                })
            })
        ]
    });
export const RegionAndDateFilter = (props)=>/*#__PURE__*/ _jsxs("fieldset", {
        className: "o-filter o-filter--two",
        children: [
            /*#__PURE__*/ _jsx("legend", {
                className: "sr-text",
                children: "Filter activiteiten op datum en plaats"
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "o-filter__inner",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "o-filter__item",
                        children: [
                            /*#__PURE__*/ _jsx("label", {
                                className: "o-filter__label text--s",
                                htmlFor: "rd-date",
                                children: "Wanneer?"
                            }),
                            /*#__PURE__*/ _jsx(PeriodFilter, {
                                ...props
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "o-filter__item",
                        children: [
                            /*#__PURE__*/ _jsx("label", {
                                className: "o-filter__label text--s",
                                htmlFor: "rd-region",
                                children: "Waar?"
                            }),
                            /*#__PURE__*/ _jsx(RegionFilter, {
                                ...props
                            })
                        ]
                    })
                ]
            })
        ]
    });
export const RegionAndDateFilterWithDatePicker = (props)=>{
    const { selectedPeriod, selectPeriod } = props;
    const moment = Moment(selectedPeriod, 'DD-MM-YYYY');
    const date = moment.isValid() ? moment.toDate() : null;
    return /*#__PURE__*/ _jsxs("fieldset", {
        className: "o-filter o-filter--three",
        children: [
            /*#__PURE__*/ _jsx("legend", {
                className: "sr-text",
                children: "Filter activiteiten op datum en plaats"
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "o-filter__inner",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "o-filter__item",
                        children: [
                            /*#__PURE__*/ _jsx("label", {
                                className: "o-filter__label text--s",
                                htmlFor: "rd-date",
                                children: "Wanneer?"
                            }),
                            /*#__PURE__*/ _jsx(PeriodFilter, {
                                ...props
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "o-filter__item",
                        children: [
                            /*#__PURE__*/ _jsx("label", {
                                className: "o-filter__label text--s",
                                htmlFor: "rd-datepicker",
                                children: "Kies een datum"
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: `o-filter__field form__select form__item--icon left${isFilterPeriod(selectedPeriod) ? ' form__select--visually-disabled' : ''}`,
                                children: [
                                    /*#__PURE__*/ _jsx(DatePicker, {
                                        locale: "nl",
                                        dateFormat: "dd MMMM yyyy",
                                        placeholderText: "Of kies een dag.",
                                        minDate: new Date(),
                                        selected: date,
                                        onChange: (newDate)=>selectPeriod(newDate.toLocaleDateString('nl-NL').toString())
                                    }),
                                    /*#__PURE__*/ _jsx("svg", {
                                        width: "20",
                                        height: "22",
                                        "aria-hidden": "true",
                                        children: /*#__PURE__*/ _jsx("use", {
                                            xlinkHref: "#icon--calendar-dnb"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "o-filter__item",
                        children: [
                            /*#__PURE__*/ _jsx("label", {
                                className: "o-filter__label text--s",
                                htmlFor: "rd-region",
                                children: "Waar?"
                            }),
                            /*#__PURE__*/ _jsx(RegionFilter, {
                                ...props
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
{}